enum ActionTypes {
  FETCH_CHECKOUT_CONFIGURATION_REQUEST = 'FETCH_CHECKOUT_CONFIGURATION_REQUEST',
  FETCH_CHECKOUT_CONFIGURATION_SUCCESS = 'FETCH_CHECKOUT_CONFIGURATION_SUCCESS',
  FETCH_CHECKOUT_CONFIGURATION_FAILURE = 'FETCH_CHECKOUT_CONFIGURATION_FAILURE',
}

export default ActionTypes;
